import React from "react";
import cn from "classnames";
import Spinner from "../common/Spinner";
import styles from "./Button.module.scss";
export default function Button({ label, onClick, kind, isLoading, className }) {
    const primaryCss = kind == "primary" ? "btn primary" : "btn";
    return (React.createElement("button", { className: cn("button", "button-ghost", primaryCss, styles.btn, className), onClick: onClick },
        !isLoading && label,
        isLoading && React.createElement(Spinner, { size: "mini" })));
}
